module.exports = __webpack_public_path__ + "img/achievement_15.1c3168d4.png";